<template>
  <div>
    <v-container class="py-0">
      <transition name="fade" mode="out-in" appear>
        <PageTitle class="d-block d-sm-none">Outgoing payments</PageTitle>
      </transition>

      <transition name="slide-left-fade" mode="out-in" appear>
        <v-tabs
          v-model="tab"
          class="mt-5 mt-sm-1"
          color="tabColor"
          slider-color="tabColor"
          center-active
          background-color="tertiary"
          show-arrows
          height="55"
        >
          <v-tab ripple>
            Landlords
          </v-tab>
          <v-tab ripple>
            Tenants 
          </v-tab>
          <v-tab>
            Contractors
          </v-tab>
          <v-tab>
            All
          </v-tab>
          <v-spacer></v-spacer>
          <span class="d-none d-sm-block">
            <PageTitle>Outgoing payments</PageTitle>
          </span>
        </v-tabs>
      </transition>

      <transition name="slide-fade" mode="out-in" appear>
        <div>
          <v-tabs-items class="pt-2 tertiary" v-model="tab">
            <v-tab-item>
              <OutgoingPaymentsTable
                :headers="headers"
                :tableData="landlordsToPay || []"
                :isLoading="landlordsLoading"
                msg="Landlords"
                icon="mdi-account-tie"
              />              
            </v-tab-item>
            <v-tab-item>
              <OutgoingPaymentsTable
                :headers="headers"
                :tableData="tenantsToPay || []"
                :isLoading="tenantsLoading"
                msg="Tenants"
                icon="mdi-home-account"
              />                     
            </v-tab-item>            
            <v-tab-item>
              <OutgoingPaymentsTable
                :headers="headers"
                :tableData="contractorsToPay || []"
                :isLoading="contractorsLoading"
                msg="Contractors"
                icon="mdi-tools"
              />                      
            </v-tab-item>  
            <v-tab-item>
              <OutgoingPaymentsTable
                :headers="headers"
                :tableData="allToPay || []"
                :isLoading="allLoading"
                msg="All"
                icon="mdi-person"
              />                      
            </v-tab-item>  
          </v-tabs-items>
        </div>
        
      </transition>
    </v-container>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {mapGetters} from 'vuex'
import OutgoingPaymentsTable from '@/components/OutgoingPayments/OutgoingPaymentsTable.vue'
import PageTitle from '@/components/Slots/PageTitle.vue';

export default {
  components: {
    OutgoingPaymentsTable,
    PageTitle
  },
  data() {
    return {
      tab: null,
      loadedTabs: {
        landlords: false,
        tenants: false,
        contractors: false,
        all: false
      },
      headers: [
        {
          text: 'Name',
          align: 'left',
          value: 'PayeeName',
          sortable: true,
        },
        { text: 'Amount', value: 'PaymentAmount', sortable: true, sort: (a, b) => b - a},
        { text: 'Last payment', value: 'LastPaymentAmount', sortable: true, sort: (a, b) => b - a, align: 'center'},
        { text: 'Account Number', value: 'BankAccount'},
        { text: 'Payment status', value: 'OnHold', sortable: true},
        { text: 'Actions', value: 'pauseResume', sortable: false },
        { text: '', value: 'actions', sortable: false, align: 'end' },
        // { text: 'Pending invoice', value: 'pending'},
        // { text: 'Past invoices', value: 'download'},
        // { text: 'Support', value: 'Message', sortable: false },
      ],
    }
  },
  created() {
    // Only load the first tab on initial load
    this.loadLandlordsData()
    this.loadedTabs.landlords = true
  },
  watch: {
    tab(newTab) {
      // Load data for the selected tab if not already loaded
      const tabMap = {
        0: 'landlords',
        1: 'tenants',
        2: 'contractors',
        3: 'all'
      };
      
      const tabType = tabMap[newTab];
      if (tabType && !this.loadedTabs[tabType]) {
        this.loadTabData(tabType);
        this.loadedTabs[tabType] = true;
      }
    }
  },
  methods: {
    async loadTabData(tabType) {
      switch(tabType) {
        case 'landlords':
          await this.loadLandlordsData();
          break;
        case 'tenants':
          await this.loadTenantsData();
          break;
        case 'contractors':
          await this.loadContractorsData();
          break;
        case 'all':
          await this.loadAllData();
          break;
      }
    },
    async loadLandlordsData() {
      await this.$store.dispatch('OutgoingPayments/getLandlordsPayments');
    },
    async loadTenantsData() {
      await this.$store.dispatch('OutgoingPayments/getTenantsPayments');
    },
    async loadContractorsData() {
      await this.$store.dispatch('OutgoingPayments/getContractorsPayments');
    },
    async loadAllData() {
      // Load zero balance payments if not already loaded
      if (!this.$store.state.OutgoingPayments.zeroBalance) {
        await this.$store.dispatch('OutgoingPayments/getZeroBalancePayments');
      }
    }
  },
  computed: {
    ...mapState({
      landlordsToPay: state => state.OutgoingPayments.landlordsToPay,
      tenantsToPay: state => state.OutgoingPayments.tenantsToPay,
      contractorsToPay: state => state.OutgoingPayments.contractorsToPay,
      landlordsLoading: state => state.OutgoingPayments.loading.landlords,
      tenantsLoading: state => state.OutgoingPayments.loading.tenants,
      contractorsLoading: state => state.OutgoingPayments.loading.contractors,
      zeroLoading: state => state.OutgoingPayments.loading.zero
    }),
    ...mapGetters({
        allToPay: 'OutgoingPayments/getAllOutgoingPayments'
    }),
    allLoading() {
      // All tab is loading if any of the individual tabs are loading
      return this.landlordsLoading || this.tenantsLoading || this.contractorsLoading || this.zeroLoading;
    }
  }
}
</script>

<style scoped>
.panel-content {
  margin: 1rem 0;
}
</style>
